module.exports = __webpack_public_path__ + "static/media/mcdonals-logo.1fc73ef2.png";